import useUpdateEffect from './useUpdateEffect';
var useDebounce = function (fn, ms, deps) {
    if (ms === void 0) { ms = 0; }
    if (deps === void 0) { deps = []; }
    useUpdateEffect(function () {
        var timeout = setTimeout(fn, ms);
        return function () {
            clearTimeout(timeout);
        };
    }, deps);
};
export default useDebounce;
